import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import { toSearchResultsLink } from 'lib/links';
import placeholder from 'lib/placeholder';

const SearchResultsBreadcrumb = ({ queryTypeName, searchQuery }) => (
  <div className="mx-4 lg:mx-0">
    <Breadcrumb className="pt-0 md:mx-0">
      <BreadcrumbItem href={toSearchResultsLink(searchQuery)}>
        {placeholder('breadcrumbs.searchResults')}
      </BreadcrumbItem>
      {queryTypeName && <BreadcrumbItem>{queryTypeName}</BreadcrumbItem>}
    </Breadcrumb>
  </div>
);

SearchResultsBreadcrumb.propTypes = {
  queryTypeName: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
};

export default SearchResultsBreadcrumb;
